import { t } from 'ember-intl';
import { PhFilePdf, PhWarning } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

interface AcceptedBannerSignature {
  Args: {
    filename: string;
  };
  Element: HTMLDivElement;
}

const AcceptedBanner: TOC<AcceptedBannerSignature> = <template>
  <div
    class="flex items-start gap-3 border-l-4 border-amber-500 bg-amber-50 px-4 py-3 last:rounded-b-xl"
    role="status"
    data-test-accepted-banner
    ...attributes
  >
    <PhWarning @size="18" @weight="fill" class="mt-0.5 shrink-0 text-amber-600" />
    <div class="flex min-w-0 flex-1 flex-wrap items-center gap-1.5 text-sm">
      <PhFilePdf @size="14" class="shrink-0 text-amber-700" />
      <span class="truncate font-medium text-amber-800">{{@filename}}</span>
      <span class="text-amber-700">
        {{t "tas.attachments.accepted_warning"}}
      </span>
    </div>
  </div>
</template>;

export default AcceptedBanner;
